import { cart } from './cart';
import { listing } from './listing';
import { dialog } from './dialog';
import { search } from './search';

export default Alpine => {
  Alpine.store('cart', cart);
  Alpine.store('listing', listing);
  Alpine.store('dialog', dialog);
  Alpine.store('search', search);
};
